import { render, staticRenderFns } from "./MiDataTableAction.vue?vue&type=template&id=10a482bc&"
import script from "@/components/MiDataTable/MiDataTableAction/MiDataTableAction.ts?vue&type=script&lang=ts&"
export * from "@/components/MiDataTable/MiDataTableAction/MiDataTableAction.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
